"use client"

import { RetailDisplayPaymentOption } from "@lib/clients/nelo-api-client"

interface InstallmentOptionProps {
  option: RetailDisplayPaymentOption
  isSelected: boolean
  onSelect: (installments: number) => void
}

const InstallmentOption: React.FC<InstallmentOptionProps> = ({ option, isSelected, onSelect }) => {
  return (
    <div
      className={`relative cursor-pointer rounded-lg border p-4 transition-colors ${isSelected ? "border-blue-500 bg-white" : "border-gray-300 bg-white"} `}
      onClick={() => onSelect(option.installments)}
    >
      <div className="flex items-start">
        <input type="radio" checked={isSelected} readOnly={true} className="form-radio mt-1 h-4 w-4 cursor-pointer text-blue-600" />

        <div className="ml-3 flex-1">
          <div className="flex flex-col">
            <div className="mb-2 flex items-baseline">
              <span className="text-md font-bold text-[#007bff]">{option.title}</span>
            </div>

            <div className="flex w-full items-center justify-start">
              <span className="text-sm text-gray-600">{option.subtitle}</span>
              <span className="ml-3 rounded bg-blue-50 px-2 py-0.5 text-xs text-[#007bff]">Sin intereses</span>
            </div>
          </div>
        </div>
      </div>

      {isSelected && (
        <div className="mt-3 rounded bg-blue-50 p-2">
          <div className="flex items-center">
            <svg className="mr-2 h-5 w-5 text-[#007bff]" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            <div className="flex flex-col">
              <span className="text-sm font-medium">Plan seleccionado</span>
              <span className="text-xs text-[#007bff]">{option.footerNote}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default InstallmentOption
